// Heavily inspired by VSCode's keybindings.json
export function getKeyboardEventKeybinding(event: KeyboardEvent | React.KeyboardEvent): string {
    const segments: string[] = [];

    if (event.ctrlKey) {
        segments.push('ctrl');
    }

    if (event.shiftKey) {
        segments.push('shift');
    }

    if (event.altKey) {
        segments.push('alt');
    }

    if (event.metaKey) {
        segments.push('cmd');
    }

    segments.push(event.key);

    return segments.join('+');
}

export const SEARCH_KEY_COMBINATIONS = ['ctrl+f', 'cmd+f', 'ctrl+F', 'cmd+F', 'F3'];
